import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {
    CompanySettingModel,
    DailyTransactionTypeEnum, UserConfigurationModel,
    UserSettingModel,
    UserTransactionsSettingResponseModel
} from "../../models";
import {getCompanySettings} from "../../components/transactions/common/businessLogic/transactionBl";
import {getUserSetting, getUserTransactionsSettings} from "../../serviceBroker/userApiServiceBroker";
import {getUserId} from "../../utils";
import {SystemConfiguration} from "../../configuration";
import {companySettingInitialValues,userSettingInitialValues,userTransactionsSettingInitialValues} from "../../components/transactions/common/initialValues/initialValues";

export const useUserConfiguration=(transactionType:DailyTransactionTypeEnum,setLoading?:Dispatch<SetStateAction<boolean>>)=>{
    //#region functions
    const makeSafeArray = <T>(input: T[] | null | undefined): T[] => {
        return Array.isArray(input) ? input : [];
    };
    //#endregion
    //#region useEffect
    useEffect(() => {
        const fillData = async () => {
            if (setLoading) setLoading(true);
            await fillBasicDataPromiseAll();
            if (setLoading) setLoading(false);
        };
        fillData().then(() => {
        });
    }, []);
    //#endregion
    //#region state
    const [userSetting, setUserSetting] = useState<UserSettingModel>(userSettingInitialValues);
    const [companySetting,setCompanySetting]=useState<CompanySettingModel>(companySettingInitialValues)
    const [userTransactionSetting, setUserTransactionSetting] = useState<UserTransactionsSettingResponseModel>(userTransactionsSettingInitialValues);
    const [userTransactionSettingList, setUserTransactionSettingList] = useState<UserTransactionsSettingResponseModel[]>([]);
    //#endregion
    //#region function
    const fillBasicDataPromiseAll = async () => {
        const [
            _userSetting,
            _userTransactionSettingList,
            _companySetting
        ] = await Promise.all([
            getUserSetting(getUserId()),
            getUserTransactionsSettings(
                [
                    DailyTransactionTypeEnum.SalesInvoice,
                    DailyTransactionTypeEnum.PurchasesInvoice,
                    DailyTransactionTypeEnum.SalesRefund,
                    DailyTransactionTypeEnum.PurchasesRefund,
                    DailyTransactionTypeEnum.Order,
                    DailyTransactionTypeEnum.ShowPrice,
                    DailyTransactionTypeEnum.POSSales,
                    DailyTransactionTypeEnum.POSSalesRefund,
                    DailyTransactionTypeEnum.POSRestaurant,
                    DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
                    DailyTransactionTypeEnum.ReturnPOSRestaurant,
                ],
                true,
                SystemConfiguration.cacheKey_Configurations.setting.userTransactionSettingsList
            ),
            getCompanySettings()
        ]);
        setUserSetting(_userSetting??userSettingInitialValues);
        setUserTransactionSettingList(_userTransactionSettingList);
        const currentTransactionSetting = _userTransactionSettingList?.find(
            (p) => p.TransactionType_ID === transactionType
        ) || null;
        setUserTransactionSetting(currentTransactionSetting || userTransactionsSettingInitialValues);
        setCompanySetting(_companySetting);
    }
    //#endregion
    return {
        userConfiguration:{
            userSetting,
            companySetting,
                userTransactionSetting,
            userTransactionSettings:userTransactionSettingList
        } as UserConfigurationModel,
    };
}